



































import { Vue, Prop } from 'vue-property-decorator'
import Component from 'vue-class-component'
import PriceConfig from '@/dto/price_config/PriceConfig'
import priceConfigsStore from '@/stores/PriceConfigStore'
import PriceConfigRow from '@/components/price-configs/PriceConfigRow.vue'
import PriceConfigTableHeader from '@/components/price-configs/PriceConfigTableHeader.vue'

@Component({
  components: { PriceConfigTableHeader, PriceConfigRow },
})
export default class WeightsTable extends Vue {
  @Prop(Array)
  public priceConfigs: PriceConfig[]

  priceConfigsStore = priceConfigsStore

  pagination = {
    rowsPerPage: 1000,
  }

  columns = [
    {
      name: 'pattern',
      align: 'left',
      label: 'Паттерн',
      field: 'pattern',
      sortable: true,
    },
    {
      name: 'currencyCode',
      align: 'left',
      label: 'Валюта',
      field: 'currencyCode',
      sortable: true,
    },
    {
      name: 'actions',
      align: 'left',
      label: '',
      field: 'actions',
    },
  ]

  get priceConfig() {
    return this.priceConfigsStore.priceConfig
  }

  get selectedRow() {
    return this.priceConfig ? [this.priceConfig] : []
  }
}
